import { searchCarForList} from "../model/car"

export const setViewMode = (mode) => {
    return {
        type: "SET_VIEW_MODE",
        payload: mode
    }
}

export const setFilter = (filter) => {
    return {
        type: "SET_FILTER",
        payload: filter
    }
}


export const searchCarList = (filter) => {
    return {
        type: "SEARCH_CAR_LIST",
        payload: searchCarForList(filter)
    }
}

export const searchCarListMore = (filter) => {
    return {
        type: "SEARCH_CAR_LIST_MORE",
        payload: searchCarForList(filter)
    }
}







// WEBPACK FOOTER //
// ./src/actions/carFindingAct.js